// API配置
export const API_BASE_URL = 'https://api.91aitv.com';
export const API_ENDPOINT = `${API_BASE_URL}/api.php/provide/vod/at/json`;

// 默认分页大小
export const DEFAULT_PAGE_SIZE = 18;
// 网站标题
export const SITE_TITLE = '十分阳光影院';